import { render } from "./SpotCheckbox.vue?vue&type=template&id=840e5b28&scoped=true"
import script from "./SpotCheckbox.vue?vue&type=script&lang=js"
export * from "./SpotCheckbox.vue?vue&type=script&lang=js"

import "./SpotCheckbox.vue?vue&type=style&index=0&id=840e5b28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-840e5b28"]])

export default __exports__